import { chartColors } from "@/styles/theme/colors";

/**
 * Gets a default color by cycling through the fixed chartColors
 * @param {number} index - The index of the color
 * @returns {Object} An object containing the color name, hex code, and next index
 */
export const getDefaultColor = (index) => {
    const colorKeys = Object.keys(chartColors);
    // Use modulo to cycle through the colors
    const colorIndex = index % colorKeys.length;
    
    return {
        index: index++,
        color: colorKeys[colorIndex],
        hex: chartColors[colorKeys[colorIndex]],
    };
}